import { render, staticRenderFns } from "./ModalCriterio5.vue?vue&type=template&id=57eccb08&scoped=true"
import script from "./ModalCriterio5.vue?vue&type=script&lang=js"
export * from "./ModalCriterio5.vue?vue&type=script&lang=js"
import style0 from "./ModalCriterio5.vue?vue&type=style&index=0&id=57eccb08&prod&scoped=true&lang=css"
import style1 from "./ModalCriterio5.vue?vue&type=style&index=1&id=57eccb08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eccb08",
  null
  
)

export default component.exports